import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';
import { CmsRenderState } from '@features/cms-render/domain/state/cms-render.state';

/**
 * Función para retornar la Store del Checkout
 */
export const getCmsRenderState = createFeatureSelector<CmsRenderState>('cms-render');
export const getCmsPages = createSelector(getCmsRenderState, (state: CmsRenderState) => state.pages);

export const getStatusCmsPage = createSelector(getCmsRenderState, (state: CmsRenderState) => state.statusPage);
export const getCmsThemePage = createSelector(getCmsRenderState, (state: CmsRenderState) => state?.theme);
export const getCmsTitleSection = createSelector(getCmsRenderState, (state: CmsRenderState) => {
    return state.titleSection;
});

export const getProducts = createSelector(getCmsRenderState, (state: CmsRenderState) => state.products);
export const getContentBySlug = (slug: string) => createSelector(getCmsPages, (pages: Record<string, ContentItemTree>) => {
    return pages[slug];
});

export const getContentBySlugAndIsVip = (slug: string, isVip = undefined) =>
    createSelector(getCmsPages, (content: any[]) => {
        return content.filter((x) => {
            if (isVip !== undefined) {
                return x.slug === slug && x.isVip === isVip;
            }

            return x.slug === slug;
        });
    });

export const getShowCountdown = (slug: string) => createSelector(getStatusCmsPage, (states) => {
    const cont = states?.[slug];
    if (!cont) return null;
    return cont.showCountdown;
});

export const getCmsSectionFocused = createSelector(getCmsRenderState, (state: CmsRenderState) => state.sectionFocused);

export const getShowCmsTooltipsStatus = createSelector(
    getCmsRenderState,
    (state: CmsRenderState) => state.showCmsTooltipsStatus,
);
